import React from 'react';

const SocAsAService = () => {
  return (
    <section className="relative py-32 ">
      <div className="max-w-[1400px] mx-auto px-4">
        
        {/* The Background Card Wrapper */}
        <div className="relative w-full rounded-[40px] border border-white/25 min-h-[600px] flex flex-col items-center">
          
          {/* Grid Wrapper */}
          <div className="absolute inset-0 overflow-hidden rounded-[40px] pointer-events-none">
            <div 
              className="absolute inset-0 opacity-[0.03]" 
              style={{ 
                backgroundImage: `linear-gradient(#3ccc2fff 1px, transparent 1px), linear-gradient(90deg, #3ccc2fff 1px, transparent 3px)`, 
                backgroundSize: '40px 40px' 
              }}
            />
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-gradient-to-t from-green-600/5 to-transparent" />
          </div>

          {/* 1. THE FLOATING MAIN CARD */}
          <div className="relative z-30 w-full max-w-4xl px-4 -mt-16 sm:-mt-20"> 
            <div className="relative overflow-hidden rounded-3xl bg-gradient-to-b from-green-600 to-[#061a11] p-[1.5px] shadow-[0_30px_60px_rgba(0,0,0,0.9)]">
              
              {/* Thin Orange Inner Border */}
              <div className="absolute inset-3 md:inset-5 rounded-2xl border border-orange-500/30 pointer-events-none z-10"></div>

              {/* Content Area */}
              <div className="relative z-20 bg-[#06140f]/90 backdrop-blur-3xl rounded-[22px] px-6 py-12 md:py-16 flex flex-col items-center text-center">
                
                {/* Brand Logo Section */}
                <div className="mb-1 flex flex-col items-center">
                <div className="mb-1 transition-transform duration-300 hover:scale-110"> 
                    <img 
                    src="/icon.png" 
                    alt="Secuwall Icon" 
                    className="w-16 h-16 lg:w-20 lg:h-20 object-contain" 
                    />
                </div>
                <span className="text-green-400/60 font-bold tracking-[0.2em] uppercase text-[15px] mb-2">
                    SecuWall Technologies Limited
                </span>
                </div>

                <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 tracking-tight leading-[1.1]">
                  SOC-as-a-Service 
                </h2>

                <p className="text-green-100/70 text-sm md:text-base max-w-xl leading-relaxed mb-10">
                  Your Full Outsourced Security Operations Center
                </p>

                
              </div>
            </div>
          </div>

          {/* 2. THE CONTENT BELOW THE FLOATING CARD */}
          <div className="relative z-10 mt-12 mb-20 text-center px-4">
             <h3 className="text-white text-3xl md:text-4xl font-bold tracking-tighter mb-4">
                Why spend months hiring experts and millions building infrastructure?
             </h3>
             <p className="text-green-500/60 font-mono text-sm tracking-[0.1em] uppercase">
                SecuWall SOC-as-a-Service gives you a complete, fully-managed 24/7 Security Operations Center that integrates seamlessly with your existing tools and stack. 
                We handle continuous monitoring, log analysis, alerting, compliance oversight, 
                and security operations — so your team can focus on core business without the burden of running a SOC.
             </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SocAsAService;